import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import { GridToolbarFilterButton } from '@mui/x-data-grid'
import Close from 'mdi-material-ui/Close'
import Delete from 'mdi-material-ui/Delete'
import Magnify from 'mdi-material-ui/Magnify'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import ConfirmDialog from '../../utils/dialog'


const StaffToolbar = props => {
  const { numSelected, selected, setReload } = props
  const [open, setOpen] = useState(false);

  const DeleteStaff = async () => {
    selected.forEach(async user => {
      try {
        await apiService.delete(`/staff/${user.userid}`);
        toast.success('삭제되었습니다.');
        setReload(reload => reload + 1);
      } catch (error) {
        console.error(error);
      }
    });
  }

  const handleConfirm = () => {
    setOpen(false);
    DeleteStaff()
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={() => { setOpen(true) }} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}

        <TextField
          variant='standard'
          value={props.value}
          onChange={props.onChange}
          placeholder='이름 검색'
          InputProps={{
            startAdornment: <Magnify fontSize='small' />,
            endAdornment: (
              <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                <Close fontSize='small' />
              </IconButton>
            )
          }}
          sx={{
            width: {
              xs: 1,
              sm: 'auto'
            },
            m: theme => theme.spacing(1, 0.5, 1.5),
            '& .MuiSvgIcon-root': {
              mr: 0.5
            },
            '& .MuiInput-underline:before': {
              borderBottom: 1,
              borderColor: 'divider'
            }
          }}
        />
      </Box>
      <ConfirmDialog 
          open={open}
          title={'Staff 삭제'}
          content={'선택된 Staff을 삭제하시겠습니까?'}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
      />
    </Box>
  )
}

export default StaffToolbar
